/*
 * カメラのプレビュー。
 *
 * 縦横比を固定して枠を先に確保する。映像が届いてから高さが決まる作りにすると、起動の
 * 瞬間にモーダルの中身が跳ねる。
 */

.frame {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: var(--mantine-radius-md);
  background: var(--mantine-color-dark-9);
}

.video {
  width: 100%;
  height: 100%;
  /* 枠を埋める。QR は画面中央に写るので、端が切れても読み取りに影響しない。 */
  object-fit: cover;
}

.hidden {
  display: none;
}
